import React from 'react'
import ReactDOM from 'react-dom'

import Gallery from '../components/gallery'


document.addEventListener((typeof Turbolinks === 'undefined' ? 'DOMContentLoaded' : 'turbolinks:load'), () => {
  const container = document.getElementsByTagName('gallery')[0];
  if(!!container){
    ReactDOM.render(
      <Gallery 
        galleryUrl={container.getAttribute("gallery-url")}
        imageIds={container.getAttribute("image-ids")}
        activeImageId={container.getAttribute("active-image-id")}
      />,
      container,
    )
  }
})
